import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  styled,
  Pagination,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { getApiData } from "../../utils/APIHelper";
import ProposalDetails from "./components/ProposalDetails";
import MobileProjectCards from "./components/MobileProjectCards";
import MobileStatistics from "./components/MobileStatistics";
import { updateUserData } from "../../utils/CommonFunction";
import { useTokenValidation } from "../../components/hooks/useTokenValidation";
import SecurityPolicyModal from "../../components/SecurityPolicyModal";

const StyledHeading = styled("h2")({
  color: "#0D0D0E",
  fontFamily: "Inter Tight",
  fontSize: "24px",
  fontWeight: "500",
});

export default function Projects() {
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Token validation hook
  const { showSecurityModal, handleSecurityModalClose } = useTokenValidation();

  const fetchData = async (currentPage) => {
    setLoading(true);
    try {
      const baseUrl =
        "api/project/list-contractor-project?status=ongoing,delivered,in_warranty,completed";
      const url =
        currentPage === 1
          ? `${baseUrl}&per_page=10`
          : `${baseUrl}&page=${currentPage}&per_page=10`;

      const response = await getApiData(url, "GET", {}, {}, false);
      const newDetails = response?.data || [];
      setTotalPages(response?.total_pages || 0);
      setDetails(newDetails);
    } catch (error) {
      console.error("Something went wrong", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    updateUserData();
  }, []);

  useEffect(() => {
    fetchData(page);
  }, [page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const DesktopView = () => (
    <>
      <ProposalDetails details={details} />
      <center
        style={{
          alignSelf: "center",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
          style={{
            alignSelf: "center",
            marginTop: "1vh",
          }}
        />
      </center>
    </>
  );

  const MobileView = () => (
    <>
      <MobileStatistics />
      <MobileProjectCards details={details} loading={loading} />
      <center
        style={{
          alignSelf: "center",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
          color="primary"
          style={{
            alignSelf: "center",
            marginTop: "1vh",
          }}
        />
      </center>
    </>
  );

  return (
    <div style={{ height: "100%" }}>
      <Box
        sx={{
          typography: "body1",
          backgroundColor: "#fff",
          height: "100%",
          borderRadius: "6px",
          fontFamily: "Inter Tight",
        }}
      >
        {/* Security Policy Modal */}
        <SecurityPolicyModal
          open={showSecurityModal}
          onConfirm={handleSecurityModalClose}
        />

        {isMobile ? (
          <div style={{ padding: "1rem" }}>
            {/* Mobile Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "2vh 4vw 1vh",
              }}
            >
              <Typography
                sx={{
                  fontSize: "22px",
                  fontWeight: "600",
                  color: "#0D0D0E",
                  fontFamily: "Inter Tight",
                  letterSpacing: "0",
                }}
              >
                Projects
              </Typography>
            </Box>

            <MobileView />
          </div>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4vh 2vw 2vh 2vw",
                background:
                  "linear-gradient(180deg, rgba(77, 107, 246, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%)",
              }}
            >
              <StyledHeading>Projects</StyledHeading>
            </div>
            <Box sx={{ padding: "0 1.5vw" }}>
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: 200,
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : details?.length > 0 ? (
                <DesktopView />
              ) : (
                <Typography
                  variant="body1"
                  sx={{ textAlign: "center", marginTop: 4 }}
                >
                  No data available
                </Typography>
              )}
            </Box>
          </>
        )}
      </Box>
    </div>
  );
}
